import React from "react";
import { Target, Heart, Award, Users } from "lucide-react";
import { useI18n } from "@/lib/i18n";
import PageHero from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import Seo from "@/components/Seo";

export default function About() {
  const { lang, t } = useI18n();
  const values = [
    [Target, { de: "Qualität", en: "Quality" }, { de: "Wir liefern erstklassige, saubere und wartbare Lösungen.", en: "We deliver first-class, clean and maintainable solutions." }],
    [Heart, { de: "Partnerschaft", en: "Partnership" }, { de: "Wir arbeiten als verlässlicher Partner auf Augenhöhe.", en: "We work as a reliable partner at eye level." }],
    [Award, { de: "Erfahrung", en: "Experience" }, { de: "Jahre an Erfahrung in Web, Mobile und Software.", en: "Years of experience in web, mobile and software." }],
    [Users, { de: "Fokus", en: "Focus" }, { de: "Ihr Erfolg steht im Mittelpunkt unserer Arbeit.", en: "Your success is at the center of our work." }],
  ];
  return (
    <div>
      <Seo title={t("nav.about")} />
      <PageHero eyebrow={t("nav.about")}
        title={lang === "de" ? "Wir bauen digitale Erfolgsgeschichten." : "We build digital success stories."}
        subtitle={lang === "de"
          ? "JonuzovicDesign ist eine Premium-Software-Agentur, die professionelle Websites, mobile Apps und maßgeschneiderte Unternehmenssoftware entwickelt."
          : "JonuzovicDesign is a premium software agency building professional websites, mobile apps and custom business software."} />
      <section className="container-x py-16">
        <div className="max-w-3xl text-lg text-muted-foreground leading-relaxed space-y-5">
          <p>{lang === "de"
            ? "Von der ersten Idee bis zum erfolgreichen Launch begleiten wir Sie mit modernster Technologie und einem Auge für Details. Wir wählen für jedes Projekt die passende Technologie — sei es Next.js, React, Laravel, React Native oder Flutter."
            : "From the first idea to a successful launch, we guide you with cutting-edge technology and an eye for detail. We choose the right technology for each project — be it Next.js, React, Laravel, React Native or Flutter."}</p>
          <p>{lang === "de"
            ? "Unser Anspruch: internationale Qualität, transparente Prozesse und Lösungen, die Ihr Unternehmen wirklich voranbringen."
            : "Our aspiration: international quality, transparent processes and solutions that truly move your business forward."}</p>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 mt-14">
          {values.map(([Icon, title, desc], i) => (
            <Reveal key={i} delay={i * 0.05}>
              <div className="surface p-7 h-full">
                <Icon size={26} className="text-primary mb-4" />
                <h3 className="font-display font-bold text-lg mb-2">{title[lang]}</h3>
                <p className="text-sm text-muted-foreground">{desc[lang]}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
